<template>
  <v-row :dense="$vuetify.breakpoint.xsOnly">
    <v-col cols="12">
      <div class="d-flex">
        <h2 class="d-inline-flex my-auto brand-text-heading brand-green-dark--text">
          {{ title.toLocaleUpperCase($i18n.locale) }}
        </h2>

        <v-spacer />

        <div class="d-inline-flex my-auto">
          <v-btn
            :disabled="!hasPrev"
            class="mx-1 brand-beige-dark"
            color="brand-green-dark"
            icon
            @click="onAffixClick('prev')"
          >
            <v-icon color="brand-green-dark">
              mdi-chevron-left
            </v-icon>
          </v-btn>

          <v-btn
            :disabled="!hasNext"
            class="mx-1 brand-beige-dark"
            color="brand-green-dark"
            icon
            @click="onAffixClick('next')"
          >
            <v-icon color="brand-green-dark">
              mdi-chevron-right
            </v-icon>
          </v-btn>
        </div>
      </div>

      <v-divider
        class="mt-3"
        style="border-color: var(--v-brand-green-dark-base)"
      />
    </v-col>

    <v-col cols="12">
      <v-slide-group
        ref="offersSlideGroup"
        class="offers-slider-group"
        show-arrows="always"
      >
        <v-slide-item
          v-for="(offer, idx) in offers"
          :key="`category-${idx}`"
        >
          <div
            :class="$vuetify.breakpoint.xsOnly ? 'mr-2 mb-1' : 'ml-1 mr-5 mb-1'"
            :style="`width: ${cardWidth}px;`"
          >
            <offer-card
              :item="offer"
              hover
            />
          </div>
        </v-slide-item>
      </v-slide-group>
    </v-col>
  </v-row>
</template>

<script>
import OfferSliderMixin from '@/theme/default/views/home/OfferSlider.js'

export default {
  name    : 'OfferSlider',
  mixins  : [OfferSliderMixin],
  computed: {
    cardWidth() {
      if (this.$vuetify.breakpoint.xs) return 290
      if (this.$vuetify.breakpoint.sm) return 330
      if (this.$vuetify.breakpoint.md) return 380
      if (this.$vuetify.breakpoint.lg) return 450

      return 560
    }
  }
}
</script>

<style scoped src="@/theme/default/views/home/OfferSlider.css"></style>
<style scoped>
</style>
